(() => {
  const state = document.documentElement.dataset.displayOnly === 'true';
  if (!state) return;

  // Block any form that would send to cart or checkout
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (action.includes('/cart') || action.includes('/checkout')) {
      e.preventDefault();
      e.stopPropagation();
      alert('Products are not available for direct purchase at this time.');
    }
  }, true);

  // Block buttons that try to go to checkout
  document.addEventListener('click', (e) => {
    const el = e.target.closest('a,button');
    if (!el) return;
    const href = (el.getAttribute('href') || '').toLowerCase();
    if (href.includes('/cart') || href.includes('/checkout')) {
      e.preventDefault();
      e.stopPropagation();
      alert('Products are not available for direct purchase at this time.');
    }
  }, true);

})();
